<template>
  <div id="perguntas-frequentes">
    <v-container>
      <v-card
        class="py-4 px-1"
        tile
      >
        <page-title
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Perguntas e respostas frequentes"
          home="/administracao"
        />
        <form-pergunta />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import FormPergunta from '../cadastros/perguntas'
export default {
  name: 'PerguntasFrequentes',
  components: { PageTitle, FormPergunta },
  data: () => ({

  })
}
</script>
